import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { searchBoxStyle } from "./Styles";

const SearchBoxComponent = ({ handleSearchTerm, value, placeholderprops }) => (
  <TextField
    sx={searchBoxStyle}
    placeholder={placeholderprops || "Search"}
    onChange={handleSearchTerm}
    value={value}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon sx={{ color: "#687B8E", fontSize: 22 }}/>
        </InputAdornment>
      ),
      autoComplete: "off",
    }}
  />
);

export default SearchBoxComponent;
